<template>
  <div class="rotate-device">
    <img src="/img/svg/rotate.svg" alt="" />
  </div>
</template>

<script>
export default {
  name: 'RotateDevice',
};
</script>

<style lang="scss" scoped>
.rotate-device {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;

  background-color: $color-azure;

  z-index: 999;

  display: none;
  align-items: center;
  justify-content: center;

  @include mq($until: ipadL, $and: '(orientation: landscape)') {
    display: flex;
  }

  @include mq($and: $is-not-touch-device) {
    display: none;
  }

  img {
    animation-name: rotate;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    @keyframes rotate {
      0% { transform: rotate(0deg) }
      100% { transform: rotate(360deg) }
    }
  }
}
</style>
